<template>
    <div class="financial-management">
        <div class="financial-management-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    name: 'financialManagement',
    data () {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
    .financial-management{
        position: relative;
        .financial-management-wrap{
            padding: 40px;
        }
    }
    @media screen and (max-width: 1280px){
        .financial-management{
            .financial-management-wrap{
                padding: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/financialManagementPages/financialManagement.vue